import React from "react";
import {
  Box,
  Card,
  Container,
  Grid2,
  Stack,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import fetcher from "../../api/fetcher";
import { END_POINTS } from "../../api/EndPoints";
import { fDateTime } from "../../utils/formatTime";

type TSettlementRecord = {
  _id: string;
  salesUserId: string;
  amount: number;
  utr?: string;
  remarks?: string;
  settledToBank?: {
    _id: string;
    bankName: string;
    accountNumber: string;
    ifsc: string;
  };
  settledBy?: { _id: string; fullName: string; email: string };
  createdAt: string;
  updatedAt: string;
};

function IncentiveDashboard() {
  const theme = useTheme();

  const metrics = [
    {
      title: "Incentive Earned (This Month)",
      value: "₹0",
      subtitle: "Processed",
    },
    { title: "Pending", value: "₹0", subtitle: "Advice ready" },
    { title: "Affiliates Onboarded", value: "0", subtitle: "Affiliates" },
    { title: "Top Contributor", value: "0", subtitle: "Team" },
  ];

  const [loading, setLoading] = useState<boolean>(false);
  const [payoutData, setPayoutData] = useState<TSettlementRecord[]>([]);

  useEffect(() => {
    getSettlement();
  }, []);

  const getSettlement = async () => {
    try {
      setLoading(true);
      const resp = await fetcher.get(
        END_POINTS.SALES_USER.COMMISSION_SETTLEMENT_RECORD
      );
      const data: TSettlementRecord[] = resp?.data || [];
      setPayoutData(data);
    } catch (e) {
      console.error("Failed to fetch settlement records", e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh" }}>
      {/* Header */}
      <Typography variant="h6" fontWeight="bold" mb={1}>
        My Incentives
      </Typography>

      {/* Metrics Grid */}
      <Grid2 container spacing={3} mb={4}>
        {metrics.map((metric, idx) => (
          <Grid2 key={idx} size={{ xs: 12, sm: 6, md: 3 }}>
            <Card sx={{ p: 2.5, height: "100%" }}>
              <Stack spacing={1}>
                <Typography variant="body2" color="text.secondary">
                  {metric.title}
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  {metric.value}{" "}
                  {/* <Typography
                    component="span"
                    variant="body2"
                    color="text.secondary"
                  >
                    {metric.subtitle}
                  </Typography> */}
                </Typography>
              </Stack>
            </Card>
          </Grid2>
        ))}
      </Grid2>

      {/* Payout Ledger */}
      <Card sx={{ boxShadow: "none", bgcolor: "transparent" }}>
        <Typography variant="h6" mb={1}>
          Payout Ledger
        </Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead>
              <TableRow sx={{}}>
                <TableCell>Period</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>TDS</TableCell>
                <TableCell>Net Incentive</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>UTR</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!loading && payoutData.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7}>
                    <Typography
                      variant="h3"
                      color="text.secondary"
                      textAlign={"center"}
                    >
                      No records found.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              {!loading &&
                payoutData.map((row) => {
                  const status = row.utr ? "Processed" : "Pending";
                  return (
                    <TableRow key={row._id} hover>
                      <TableCell>{fDateTime(row.createdAt)}</TableCell>
                      <TableCell>
                        ₹{Number(row.amount || 0).toLocaleString()}
                      </TableCell>
                      <TableCell>{"—"}</TableCell>
                      <TableCell>{"—"}</TableCell>
                      <TableCell>{status}</TableCell>
                      <TableCell>{row.utr || "—"}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
}

export default IncentiveDashboard;
